import { Pipe, PipeTransform } from '@angular/core';
import { formatAsDateOnlyString } from '@app/utils/datetime/datetime.utils';
@Pipe({
  name: 'appDate',
  standalone: true,
})
export class AppDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string | null {
    return formatAsDateOnlyString(value);
  }
}
